'use strict';

require('./gaStylitics');

import { bindGA, sendEventGAWithContext } from './util/analytics-util';
const { getProductData, queryAll, queryFirst, hasClass } = require('lilly/domUtil');

const { PDP_SELECTIONS, PDP_INTERACTION, CHANGE_STORE, ACCOUNT_SIGN_IN_CATEGORY, SIGN_IN_OR_CREATE_ACCOUNT_ACTION, START_LABEL, PDP_PAGE_NAME, PRODUCT_PAGE_TYPE,
    LOYALTY_ENROLLMENT_CATEGORY, INITIATE_ACTION, JOIN_CLUB_LILLY_EVENT, LOYALTY_PROGRAM_LABEL, LOYALTY_PROGRAM_ACTION, ENROLL_LOYALTY, CREATE_ACCOUNT_ACTION,
    SUBMIT_EVENT_LABEL, LOYALTY_ENROLLMENT_EVENT_NAME, VIEW_ITEM,
    SELECT_ITEM } = require('./util/constants');

/**
 * Analytics for PDPs
 */
function initEvents() {
    const { utag_data: uData = {} } = window;
    const { body } = document;

    // GA4 - view_item (UA is fired in Tealium via extensions)
    // fires on PDP and product sets
    const { product_id: productIds } = uData;
    if (Array.isArray(productIds)) {
        for (let i = 0, n = productIds.length; i < n; ++i) {
            const pId = productIds[i];
            const pName = uData.product_name[i];
            const pCategory = uData.product_category[i];
            const pPrice = uData.product_price[i];
            const pQty = uData.product_quantity[i];
            const pVariant = uData.product_variant[i];
            const pColor = uData.product_color[i];

            sendEventGAWithContext({
                event_name: VIEW_ITEM,
                product_id: pId ? [pId] : [],
                product_name: pName ? [pName] : [],
                product_category: pCategory ? [pCategory] : [],
                product_price: pPrice ? [pPrice] : [],
                product_quantity: pQty ? [pQty] : [],
                product_variant: pVariant ? [pVariant] : [],
                product_color: pColor ? [pColor] : [],
                pdp_type: 'regular',
                search_term: uData.search_term || ''
            }, queryFirst('.product-detail'));
        }
    }

    // Details/Size Drop-downs
    bindGA(queryAll('.accordion-container'), (bindElement, srcElement, e) => {
        const interaction = e.type === 'show' ? 'open' : 'close';
        let dropdownName;

        if (hasClass(bindElement, 'description-accordion')) dropdownName = 'details menu';
        else if (hasClass(bindElement, 'size-accordion')) dropdownName = 'size menu';

        if (!dropdownName) return false;

        return {
            event_name: PDP_INTERACTION,
            interaction_type: `${interaction} ${dropdownName}`,
            page_product: uData.page_product
        };
    }, {
        eventType: 'show.bs.collapse hide.bs.collapse',
        retriggerEvent: false
    });

    // Product Details Menu Open - GA360 Only
    bindGA(queryAll('.description-accordion'), bindElement => {
        const { productName, masterId, productColor } = getProductData(bindElement);

        return {
            event_category: PDP_SELECTIONS,
            event_action: 'product details',
            event_label: [productName, masterId, productColor]
        };
    }, {
        eventType: 'show.bs.collapse',
        retriggerEvent: false
    });

    // ISPU Change Store
    bindGA(queryAll('.btn-in-store-pickup'), () => {
        const store = queryFirst('.store-detail .name');
        let eLabel = '';

        if (store) {
            eLabel = [store.textContent, store.dataset.storeId];
        }

        return {
            // GA4
            event_name: PDP_INTERACTION,
            interaction_type: CHANGE_STORE,
            page_product: uData.page_product,

            // GA360
            event_category: CHANGE_STORE,
            event_action: 'click',
            event_label: eLabel
        };
    }, {
        retriggerEvent: false
    });

    // BOPIS/Shipping selection
    bindGA(queryAll('.shipping-preferences'), (bindElement, srcElement) => {
        let eAction = 'ship to address';
        let eLabel = '';

        if (srcElement.value === 'ISPU') {
            const store = queryFirst('.store-detail .name');
            eAction = 'bopis';

            if (store) {
                eLabel = [store.textContent, store.dataset.storeId];
            }
        }

        return {
            // GA4
            event_name: PDP_INTERACTION,
            interaction_type: 'change delivery method',
            delivery_method: eAction,
            page_product: uData.page_product,

            // GA360
            event_category: 'pdp delivery method',
            event_action: eAction,
            event_label: eLabel
        };
    }, {
        bindOptions: {
            targetSelectors: ['.shipping-preference']
        }
    });

    // Monogram Buttons
    bindGA(queryAll('.monogram-btn, .pdp-monogram-btn'), bindElement => {
        const { productName, masterId, productColor } = getProductData(bindElement);

        return {
            event_category: PDP_SELECTIONS,
            event_action: 'add a monogram',
            event_label: [productName, masterId, productColor]
        };
    });

    // Product Set - In This Set Widget
    bindGA(queryAll('.in-this-set'), (bindElement, srcElement) => {
        const { pid } = srcElement.dataset;
        const productContainer = document.getElementById(pid);

        if (!pid || !productContainer) return false;

        const { productName, masterId, productColor } = getProductData(productContainer);

        return {
            event_category: 'product sets',
            event_action: [productName, masterId, productColor],
            event_label: uData.page_name
        };
    }, {
        bindOptions: {
            targetSelectors: ['.sticky-nav-link']
        }
    });

    // Bazaaravoice Write Review Button (details section)
    bindGA(queryFirst('.pdp-details'), {
        event_name: PDP_INTERACTION,
        interaction_type: 'write review',
        page_product: uData.page_product
    }, {
        bindOptions: {
            targetSelectors: ['.bv_button_component_container button']
        }
    });

    //Early Access - PDP Sign In or Create Account (guest user)
    bindGA(queryFirst('.pdp-details'), (bindElement, srcElement) => {
        const { productBadge } = getProductData(srcElement);

        return {
            event_category: ACCOUNT_SIGN_IN_CATEGORY,
            event_action: SIGN_IN_OR_CREATE_ACCOUNT_ACTION,
            event_label: START_LABEL,
            page_name: PDP_PAGE_NAME,
            page_type: PRODUCT_PAGE_TYPE,
            product_badge: [productBadge]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.js-early-access-sign-in-cta']
        }
    });

    //Early Access - PDP Sign up for Loyalty (signed in but NOT loyalty member) join club lilly
    bindGA(queryFirst('.pdp-details'), (bindElement, srcElement) => {
        const { productBadge } = getProductData(srcElement);
        return {

            //GA360
            event_category: LOYALTY_ENROLLMENT_CATEGORY,
            event_action: INITIATE_ACTION,
            event_label: JOIN_CLUB_LILLY_EVENT,

            //GA4
            page_name: uData.page_name,
            page_type: uData.page_type,
            loyalty_status: uData.loyalty_status,
            logged_in_status: uData.user_loggedin_status,
            event_name: LOYALTY_ENROLLMENT_EVENT_NAME,
            interaction_type: LOYALTY_PROGRAM_ACTION,
            product_badge: [productBadge]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.early-access-sign-up']
        }
    });

    //Early Access - Create Account Button
    bindGA(queryFirst('.loyalty-early-access-register-modal'), (bindElement, srcElement) => {
        const { productBadge } = getProductData(srcElement);

        return {
            event_category: LOYALTY_PROGRAM_LABEL,
            event_action: LOYALTY_PROGRAM_ACTION,
            event_label: ENROLL_LOYALTY,
            page_name: PDP_PAGE_NAME,
            page_type: PRODUCT_PAGE_TYPE,
            product_badge: [productBadge]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.js-save-for-later-select']
        }
    });

    //Early Access - Create Account Submission
    bindGA(queryFirst('.loyalty-early-access-register-modal'), (bindElement, srcElement) => {
        const { productBadge } = getProductData(srcElement);

        return {
            event_category: ACCOUNT_SIGN_IN_CATEGORY,
            event_action: CREATE_ACCOUNT_ACTION,
            event_label: SUBMIT_EVENT_LABEL,
            product_badge: [productBadge]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.create-account-btn']
        }
    });

    // Fire upon having checkbox checked and clicking submit in Create an Account Modal on PDP
    bindGA(body, (bindElement, srcElement) => {
        const { productBadge } = getProductData(srcElement);
        return {
            event_name: LOYALTY_ENROLLMENT_EVENT_NAME,
            interaction_type: LOYALTY_PROGRAM_ACTION,
            product_badge: [productBadge]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.join-now-button']
        }
    });

    // Fire upon shoppable media product link clicked
    bindGA(body, (bindElement, srcElement) => {
        const { productName, masterId, productPrice, originalPrice } = getProductData(srcElement);
        const shoppableMediaContainer = srcElement.closest('.shoppable-media');
        const shoppableTitle = queryFirst('.shoppable-media-title', shoppableMediaContainer).innerText;
        const shoppableMediaType = queryFirst('.video-component', shoppableMediaContainer) ? 'video' : 'static media';
        const shoppableProducts = queryAll('.smtile-small .product', shoppableMediaContainer);
        const itemElem = srcElement.closest('.smtile-small .product');
        const itemPosition = (shoppableProducts && itemElem) ? shoppableProducts.indexOf(itemElem) + 1 : '';
        return {
            event_name: SELECT_ITEM,
            product_list_category: 'shoppable media ' + shoppableTitle + ' ' + shoppableMediaType,
            product_name: productName,
            product_id: masterId,
            product_price: productPrice,
            product_original_price: originalPrice,
            product_list_position: itemPosition
        };
    }, {
        bindOptions: {
            targetSelectors: ['.shoppable-media .product-tile a']
        }
    });
}

initEvents();
